import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { useState } from "react";
import StatsUI from "../molecules/StatsUI";
import { Select } from "./Select";
import NavbarFilter from "./NavbarFilter";
import CampaignForm from "./CampaignForm";
import { SelectAvatar } from "./SelectAvatar";
import { DateRangePicker } from "../atoms/DataRangePicker";
import { MultiSelect } from "./MultiSelect";
import { Modal } from "./Modal";
import { FormCategory } from "./FormCategory";

const NavbarFilterTasks = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    date: "",
    linkPrivacidad: "",
    linkTerminos: "",
    linkSitio: "",
    fileUpload: null as File | null, // Para el archivo
    beneficios: "", // Para el campo opcional
  });

  const options = [
    { id: 1, name: "Demo GYM" },
    { id: 2, name: "Test GYM" },
    { id: 3, name: "Fitmewise GYM" },
  ];

  const people = [
    {
      id: 1,
      name: "Wade Cooper",
      avatar:
        "https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 2,
      name: "Arlene Mccoy",
      avatar:
        "https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 3,
      name: "Devon Webb",
      avatar:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80",
    },
    {
      id: 4,
      name: "Tom Cook",
      avatar:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 5,
      name: "Tanya Fox",
      avatar:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 6,
      name: "Hellen Schmidt",
      avatar:
        "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 7,
      name: "Caroline Schultz",
      avatar:
        "https://images.unsplash.com/photo-1568409938619-12e139227838?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 8,
      name: "Mason Heaney",
      avatar:
        "https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 9,
      name: "Claudie Smitham",
      avatar:
        "https://images.unsplash.com/photo-1584486520270-19eca1efcce5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    {
      id: 10,
      name: "Emil Schaefer",
      avatar:
        "https://images.unsplash.com/photo-1561505457-3bcad021f8ee?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
  ];

  const statsUI = [
    {
      name: " Tareas completadas (a tiempo)",
      stat: " 5 ( 29 %) ",
    },
    {
      name: "Tareas completadas (tarde)",
      stat: " 2 ( 12 %, 3 días)",
    },
    {
      name: "Tareas no completadas",
      stat: "10 ( 59 %, 100 días) ",
    },
  ];

  const [open, setOpen] = useState(true);

  const [openModal, setOpenModal] = useState(false);

  const optionsMenu = [
    {
      name: "Etiquetas",
      functionMenu: () => setOpenModal(true),
    },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isKpisOpen, setIsKpisOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const toggleKpis = () => {
    setIsKpisOpen(!isKpisOpen);
  };

  const [errors, setErrors] = useState({
    nombre: false,
    linkPrivacidad: false,
    linkTerminos: false,
    linkSitio: false,
    fileUpload: false, // Para el archivo
  });

  //HANDLE SUBMIT
  const handleSubmit = () => {
    // Validamos los campos obligatorios
    const newErrors = {
      nombre: formData.nombre.trim() === "",
      linkPrivacidad: formData.linkPrivacidad.trim() === "",
      linkTerminos: formData.linkTerminos.trim() === "",
      linkSitio: formData.linkSitio.trim() === "",
      fileUpload: formData.fileUpload === null, // Validamos que haya un archivo cargado
    };

    // Actualizamos el estado de los errores
    setErrors(newErrors);
  };

  return (
    <div className="flex flex-1  self-stretch lg:gap-x-6 px-4 bottom  pb-2 border-b-2 ">
      <NavbarFilter
        exportData={() => {
          console.log("Exportar la informacion");
        }}
        formComponents={
          <>
            <InputWithCornerHint
              label="Tarea"
              span=""
              id="tarea"
              name="tarea"
              type="text"
              placeholder="Tarea"
            />
          </>
        }
        showPrimaryButton={false}
        toggleDrawer={toggleDrawer}
        toggleKpis={toggleKpis}
        optionsMenu={optionsMenu}
        showIcons={true}
      />
      {isDrawerOpen && (
        <div className="fixed inset-x-0 top-36 w-screen z-50 flex">
          <div
            className="fixed inset-0 bg-black opacity-50"
            onClick={toggleDrawer}
          ></div>
          <div className="relative bg-white w-full h-full shadow-xl">
            <div className="p-4">
              <form action="#" method="GET" className="flex gap-x-8">
                <Select
                  name=""
                  selected={selectedOption}
                  setSelected={() => setSelectedOption}
                  options={options}
                  tittle="Estado"
                />
                <SelectAvatar
                  selected={people[0]}
                  setSelected={setSelectedOption}
                  options={people}
                  tittle="Asignado a"
                />
                <DateRangePicker
                  value={{
                    startDate: new Date(),
                    endDate: new Date(),
                  }}
                  id="date_range"
                  label="Rango fecha"
                  onDateChange={() => {}}
                />
                <MultiSelect
                  options={[]}
                  selectedOptions={[]}
                  setSelectedOptions={() => {}}
                  title={"Etiquetas"}
                />
              </form>
            </div>
          </div>
        </div>
      )}
      {isKpisOpen && (
        <div className="fixed inset-x-0 top-36 w-screen z-50 flex">
          <div
            className="fixed inset-0 bg-black opacity-50"
            onClick={toggleKpis}
          ></div>
          <div className="relative bg-white w-full h-full shadow-xl">
            <div className="px-8 pr-8">
              <StatsUI title="KPIs" stats={statsUI} />
            </div>
          </div>
        </div>
      )}
      {/* 
      <CampaignForm
        handleSubmit={handleSubmit}
        setToggleModal={setOpen}
        toggleModal={open}
        formData={{ nombre: "", date: "", correo: "", beneficios: "" }}
      />
      */}
      <Modal
        open={openModal}
        Close={() => {
          setOpenModal(false);
        }}
        textButtonCreate="Crear"
        textButtonClose="Cancelar"
        tittleModal="Nueva categoria"
      >
        <FormCategory />
      </Modal>
    </div>
  );
};

export default NavbarFilterTasks;
